module.exports = {
  // 正式环境
  baseUrl: 'https://server.qingguangtech.com/',
  imageBaseUrl: 'https://src.qingguangtech.com/application',
  // 测试环境
  // baseUrl: 'http://58.220.10.222:8082/',
  // imageBaseUrl: 'http://58.220.10.222:19000/application',
  projectName: '协同管理系统'
}
